import { createContext } from 'react';
import { jobOpeningDetailsTabs, jobOpeningTypes } from '../types/JobOpenings';

interface IJobOpeningsContext {
  jobOpeningElements: jobOpeningTypes[],
  setJobOpeningElements: (jobOpening: jobOpeningTypes[]) => void,
  completedJobOpeningDetails: jobOpeningDetailsTabs[],
  setCompletedJobOpeningDetails:(jobOpening: jobOpeningDetailsTabs[]) => void,
  jobOpeningId?: string,
}

export const DefaultJobOpeningsState = {
  jobOpeningElements: [],
  completedJobOpeningDetails: [],
  setJobOpeningElements: () => {},
  setCompletedJobOpeningDetails: () => {},
  jobOpeningId: undefined,
};

export const JobOpeningsContext = createContext<IJobOpeningsContext>(DefaultJobOpeningsState);
